// 📂 components/Client/Table/ModuleDetailPanel/ModuleRolesTable.tsx
import React from "react";
import ModuleRolesTableHeader from "./ModuleRolesTableHeader";
import ModuleRolesTableRow from "./ModuleRolesTableRow";

/**
 * 📌 Contenedor principal de la tabla de roles del módulo.
 * 
 * 👉 Toda la lógica de datos (hooks, actualizaciones, etc.)
 *     vive dentro de ModuleRolesTableRow.
 */
const ModuleRolesTable: React.FC = () => {
  return (
    <div>
      <h4 className="mb-1 text-base font-semibold text-black dark:text-white">
        Roles con acceso
      </h4>
      <p className="mb-4 text-sm text-body dark:text-bodydark2">
        Marca los roles que pueden ver este módulo en el menú lateral.
      </p>

      <div className="overflow-x-auto rounded-lg border border-stroke dark:border-strokedark">
        <div className="inline-block min-w-full">
          <ModuleRolesTableHeader />
          <ModuleRolesTableRow />
        </div>
      </div>
    </div>
  );
};

export default ModuleRolesTable;
